import api, { request } from '../../../../api';
import { IStore } from '../../../index';
import { IEventEnrollment } from '../store';
import { IEventsActionResponse } from '../Utils/TEventsActionResponse';

export const register = async (
  state: IStore,
  eventId: number,
  addons: number[],
  coupon?: string,
  creditCardId?: number
): Promise<IEventsActionResponse> => {
  const body: any = {
    addons,
    credit_card: creditCardId,
    event: eventId
  };
  if (coupon) {
    body.coupon = coupon;
  }
  const response = await request.post(`${api.eventRegistration}settle/`, body);

  if (response.error) {
    return { errors: { events: { msg: 'Error registering to Event.' } } };
  }

  const enrollment: IEventEnrollment = response;
  const event = state.events[eventId];
  return {
    events: {
      ...state.events,
      [eventId]: {
        ...event,
        enrollment
      }
    }
  };
};
